export const baseUrlClient = "https://dblpm.edulink-indonesia.com";
export const baseUrlClientTest = "http://localhost:8001";
export const baseUrlClientOSN = "https://node-osn.edulink-indonesia.com/api";
export const imageUrl =
  "https://dblpm.edulink-indonesia.com/sliderHeader-images/";
